import { formatDateWithoutTime } from '@/lib/utils'
import { FinancialModel } from '../../api/types'
import { FinancialModelSettings, YearMonth } from '../store/financialModelSettingsStore'
import { removeUndefinedValues } from '@/lib/utils/parsers'
import { Currency } from '@/global/currencies'

export const normalizeSettingsStore = (settings: Partial<FinancialModelSettings>): Partial<FinancialModel> =>
  removeUndefinedValues({
    id: ``,
    name: settings.general?.name,
    revenue_stream_name: settings.general?.revenue_stream_name,
    revenue_stream_type: settings.general?.revenue_stream_type,
    functional_currency: settings.currency?.functionalCurrency,
    fiscal_year_end: Number(settings.fiscalYearEnd?.companyFiscalYearEnd),
    historical_data_end_at: settings.timeframe?.historical?.endAt ? formatDateWithoutTime(new Date(settings.timeframe.historical.endAt)) : null,
    historical_data_start_at: settings.timeframe?.historical?.startAt ? formatDateWithoutTime(new Date(settings.timeframe.historical.startAt)) : null,
    forecast_data_end_at: settings.timeframe?.forecast?.endAt ? formatDateWithoutTime(new Date(settings.timeframe?.forecast?.endAt)) : null,
    forecast_data_start_at: settings.timeframe?.forecast?.startAt ? formatDateWithoutTime(new Date(settings.timeframe?.forecast?.startAt)) : null
  })

export const adaptFinancialModelToStore = (financialModel: Partial<FinancialModel>): Partial<FinancialModelSettings> => ({
  general: {
    name: financialModel.name ?? ``,
    revenue_stream_name: financialModel.revenue_stream_name ?? ``,
    revenue_stream_type: financialModel.revenue_stream_type ?? ``
  },
  currency: {
    functionalCurrency: financialModel.functional_currency as Currency
  },
  fiscalYearEnd: {
    companyFiscalYearEnd: financialModel.fiscal_year_end?.toString() as YearMonth
  },
  timeframe: {
    historical: {
      isActive: financialModel.historical_data_end_at !== null,
      endAt: financialModel.historical_data_end_at ?? null,
      startAt: financialModel.historical_data_start_at ?? null
    },
    forecast: {
      isActive: financialModel.forecast_data_end_at !== null,
      endAt: financialModel.forecast_data_end_at ?? null,
      startAt: financialModel.forecast_data_start_at ?? null
    }
  }
})
